import React, { useEffect, useRef, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MediaSlot } from './MediaSlot';
import { CelebrationBurst } from './CelebrationBurst';
import { flipBack, flipFront } from '../../data/media';
export function FlipWorksheet() {
  const [flipped, setFlipped] = useState(false);
  const [burstId, setBurstId] = useState<number | null>(null);
  const pendingBurst = useRef(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (burstId === null) return;
    const t = window.setTimeout(() => setBurstId(null), 1700);
    return () => window.clearTimeout(t);
  }, [burstId]);
  const handleClick = () => {
    const next = !flipped;
    pendingBurst.current = next && !reduce;
    if (!next) setBurstId(null);
    setFlipped(next);
  };
  const handleFlipDone = () => {
    if (pendingBurst.current && flipped) {
      pendingBurst.current = false;
      setBurstId(Date.now());
    }
  };
  return <section aria-labelledby="flip-title" className="bg-cream py-14 md:py-20" data-id="element-79" data-mp="3nnjrb8uuhu8i">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-80" data-mp="3bucg95tqqp2g">
        <h2 id="flip-title" className="font-display text-[1.75rem] font-extrabold leading-[1.15] tracking-[-0.03em] text-ink md:text-4xl" data-id="element-81" data-mp="3gn5klslarve0">
          Egy oldal. 10 perc.{' '}
          <em className="font-serif font-medium tracking-normal text-coral" data-id="element-82" data-mp="32teaahzqs7h8">Egy szív, ami újra megtelik.</em>
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-body" data-id="element-83" data-mp="3umn53vrk8mhk">
          Írd a szívekbe, ami fáj… aztán színezd őket meleg színekkel.
        </p>

        <div className="relative mx-auto mt-8 w-full max-w-[390px] [perspective:1400px]" data-id="element-84" data-mp="3fawi54qthd9">
          <motion.button type="button" onClick={handleClick} onAnimationComplete={handleFlipDone} aria-pressed={flipped} aria-label={flipped ? 'Utána — fordítsd vissza' : 'Előtte — fordítsd meg'} animate={{
          rotateY: flipped ? 180 : 0
        }} transition={{
          duration: reduce ? 0 : 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative block aspect-[1/1.414] w-full rounded-3xl text-left [transform-style:preserve-3d] focus:outline-none focus-visible:ring-2 focus-visible:ring-lavender-deep" data-id="element-85" data-mp="3ll72wbawfqof">
            <div className="absolute inset-0 overflow-hidden rounded-3xl bg-white shadow-[0_20px_40px_-20px_rgba(74,58,53,0.35)] [backface-visibility:hidden]" data-id="element-86" data-mp="ayabzzp32orc">
              <MediaSlot src={flipFront} slot="flip-front" alt="Gyógyuló szív — előtte" aspect="h-full" fit="contain" className="rounded-3xl" data-id="element-87" data-mp="1yn8978vt6v4" />
              <span className="absolute bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-lavender-deep px-6 py-2 font-display text-base font-bold uppercase tracking-wider text-white" data-id="element-88" data-mp="3t3n3ky0vypsp">
                Előtte
              </span>
            </div>
            <div className="absolute inset-0 overflow-hidden rounded-3xl bg-white shadow-[0_20px_40px_-20px_rgba(74,58,53,0.35)] [backface-visibility:hidden] [transform:rotateY(180deg)]" data-id="element-89" data-mp="1mfa1knk1qpho">
              <MediaSlot src={flipBack} slot="flip-back" alt="Gyógyuló szív — utána" aspect="h-full" fit="contain" className="rounded-3xl" data-id="element-90" data-mp="30b1s5kgwku16" />
              <span className="absolute bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-coral px-6 py-2 font-display text-base font-bold uppercase tracking-wider text-white" data-id="element-91" data-mp="358bn1fn29xwe">
                Utána ✨
              </span>
            </div>
          </motion.button>
          {burstId !== null && <CelebrationBurst key={burstId} data-id="element-92" data-mp="2hdie22fl8l7w" />}
        </div>
        <p className="mt-4 text-[15px] text-body" data-id="element-93" data-mp="2maikwfk9hs02">Koppints az oldalra, és fordítsd meg</p>
      </div>
    </section>;
}